import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const NotFound = () => {
  const accountType = useSelector((data) => data?.local?.accountType);
  const { t } = useTranslation();

  return (
    <section className="bg-light vh-100 w-100 d-flex align-items-center justify-content-center">
      <article className="text-center p-5 shadow-lg rounded bg-white">
        <i
          className="fa fa-exclamation-circle"
          style={{
            fontSize: "4rem",
            color: "#dc3545",
            marginBottom: "20px",
          }}
        />
        <h1 className="comman-heading text-danger">404</h1>
        <h2 className="comman-heading-2">{t("Page Not Found")}</h2>
        <p className="text-muted mt-3">
          {t("Oops! The page you are looking for doesn’t exist.")}
        </p>
        <Link
          to={accountType === "Buyer" ? "/" : "seller-home"}
          className="btn btn-primary mt-4"
        >
          {t("Go to Home")}
        </Link>
      </article>
    </section>
  );
};

export default NotFound;
